import { writable } from "svelte/store";

// export const libraryPage = writable(1);

// export const selectedImage = writable(null);

// export let isAuthenticated = writable(false);
// export const user = writable(null);

let _user = localStorage.getItem('user');
export const user = writable(_user ? JSON.parse(_user) : null);
user.subscribe((value) => {
  if (value) localStorage.setItem('user', JSON.stringify(value));
  else localStorage.removeItem('user'); // for logout
});

// let _user = localStorage.getItem('user');

// export const user = writable(_user ? JSON.parse(_user) : null);
// user.subscribe((value) => {
//     if (value) localStorage.setItem('user', JSON.stringify(value));
//     else localStorage.removeItem('user'); // for logout
//   });

// function createTitle() {
//     const {subscribe, set, update} = writable('');

//     return {
//         subscribe,
//         set: (value) => {
//             set(`${value}`)
//         },
//         clear: () => {
//             set('');
//         }
//     }
// }

// export const title = createTitle();

// import { writable, derived } from "svelte/store";

// export const isAuthenticated = writable(false);
// export const user = writable({});
// export const popupOpen = writable(false);
// export const error = writable();

// export const tasks = writable([]);

// export const user_tasks = derived([tasks, user], ([$tasks, $user]) => {
//   let logged_in_user_tasks = [];

//   if ($user && $user.email) {
//     logged_in_user_tasks = $tasks.filter((task) => task.user === $user.email);
//   }

//   return logged_in_user_tasks;
// });